<pos-table tableFormId="customerTable" [data]="customers" (dataChange)="getCustomerData($event)"
  [headers]="getCustomerHeaders()" [filters]="getCustomerFilters()" [badgeSuccessValues]="[
'RETAIL',
'EMPLOYEE',
'FRANCHISED'
]" [badgeSecondaryValues]="['CORPORATE',
'INTERCOMPANY',
'LEGAL_ENTITY'] " [itemsPerPage]="10" (rowClick)="selectCustomer($event)">
</pos-table>
